import { AddressDetails } from '../../types/address.types';
import { CustomerSynchronizedStatus } from '../customer/types/customer.enum';
import { SalesRepresentative } from '../sales-representative/sales-representative.types';
import { Locales } from '../translation/messages';
import { UserStatus } from '../user-admin/user.types';
import { Ability } from '../users/ability.types';
import { UserRole } from '../users/roles';
import { MyNetworkRulesType } from './myNetwork.rules';

export type StoreOrBrandAddress = {
  id: string;
  name: string;
  principal: boolean;
  address: AddressDetails;
};

export type StoreOrBrand = {
  id: string;
  enablePublicShowroom?: boolean;
  customerSupportPhone?: string;
  name: string;
  title?: string;
  logoUrl?: string;
  bannerUrl?: string;
  slug: string;
  addresses: Array<StoreOrBrandAddress>;
};

export type MyNetworkUser = {
  id: string;
  userId: string;
  sellerId: string;
  email: string;
  phone?: string;
  name: string;
  surname?: string;
  cpf: string;
  profileUrl: string;
  status: UserStatus;
};

export type Connection = {
  id: string;
  createdAt: string;
  store: StoreOrBrand;
  brand: StoreOrBrand;
  salesRepresentatives: SalesRepresentative[];
  customerSynchronizedStatus: CustomerSynchronizedStatus;
};

type Origin = 'BRAND' | 'STORE';

type InviteDefaultStatus = 'SOLICITADO' | 'AGUARDANDO' | 'CONECTADO' | 'IGNORADO';

export type InviteBrandStatus = InviteDefaultStatus | 'SUGERIDO_VENDEDOR' | 'RECUSADO_ADMIN';

export type InviteStoreStatus = InviteDefaultStatus;

export type Invite = {
  id: string;
  createdAt: string;
  origin: Origin;
  brandStatus: InviteBrandStatus;
  storeStatus: InviteStoreStatus;
  message: string;
  store: StoreOrBrand;
  brand: StoreOrBrand;
  createdBy: MyNetworkUser;
  salesRepresentatives: SalesRepresentative[];
  customerSynchronizedStatus?: CustomerSynchronizedStatus;
};

export type InviteListType = 'RECEIVED' | 'SENT' | 'SUGGESTIONS';

export type SalesRepresentativeOption = Pick<SalesRepresentative, 'id' | 'name' | 'code'>;

export interface MyNetworkTabProps {
  updateNotifications: () => void;
}

export interface GetMyNetworkInviteColumnsParams {
  path: Paths;
  rules: MyNetworkRulesType;
  role: UserRole | undefined;
  isBrand: boolean;
  locale: Locales;
  ability: Ability;
  onClickMessage?: (invite: Invite) => void;
}

export enum Paths {
  EXPLORE = 'search-brands',
  CONNECTIONS = 'my-connections',
  INVITES_SENT = 'invites-sent',
  INVITES_RECEIVED = 'invites-received',
  INVITES_SUGGESTIONS = 'invites-suggestions',
}

export type MyNetworkTabsPaths =
  | Paths.EXPLORE
  | Paths.CONNECTIONS
  | Paths.INVITES_SENT
  | Paths.INVITES_RECEIVED
  | Paths.INVITES_SUGGESTIONS;

export const isValidPath = (path: string) => Object.values(Paths).includes(path as Paths);
